const nav = document.querySelector('.nav')
const icon = document.getElementById('header__burger');

icon?.addEventListener('click', function() {
  icon.classList.toggle('open');
  nav.classList.toggle('nav--active');
});